import '@material-symbols/font-400/rounded.css'
import 'react-toastify/dist/ReactToastify.css'
import '@makyoapp/makyo-ui/dist/makyo-ui.css'
import '@makyoapp/makyo-tw-ui/dist/makyo-tw-ui.css'
import './index.css'
import './makyo.css'

import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import App from './App'
import { ErrorFallbackModal } from './components/ErrorFallbackModal'
import { AuthProvider } from './context/AuthContext'
import { DayJsProvider } from './lib/dayjs'
import { ErrorBoundary } from './lib/error-boundary'
import { ReactQueryProvider } from './lib/react-query/react-query'

// Sentry.init({
//   dsn: appConfig.sentry.dsn,
//   environment: import.meta.env.MODE,
// })

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <React.StrictMode>
    <DayJsProvider>
      <ReactQueryProvider>
        <BrowserRouter>
          <AuthProvider>
            <ErrorBoundary fallbackRender={(props) => <ErrorFallbackModal {...props} />}>
              <App />
            </ErrorBoundary>
          </AuthProvider>
        </BrowserRouter>
      </ReactQueryProvider>
    </DayJsProvider>
  </React.StrictMode>
)

// Load Error Handling
window.addEventListener('vite:preloadError', (event) => {
  window.location.reload()
})

// inject app mode global variable for builder
window.appMode = 'preview'

// global prettyLog function
window.showDebug = true

window.prettyLog = (message: string, ...args: any[]) => {
  if (!window.showDebug) return
  console.info(
    `%c${message}:`,
    `background: ${typeof args.at(-1) === 'string' ? args.at(-1) : 'teal'};color:white;padding:2px`,
    ...(typeof args.at(-1) === 'string' ? args.slice(0, -1) : args)
  )
}
